// Keep the field's shape stable while opening, choosing, and closing options.
// Keyboard focus can remain on a closed dropdown; it must not change corners.
export const dropdownControlStyle = (base) => ({
  ...base,
  borderRadius: "8px",
})

// Spread into a component's own `styles` prop: `styles={{...reactSelectDropdownStyles, ...otherOverrides}}`
export const reactSelectDropdownStyles = {
  control: dropdownControlStyle,
}
